import Navbar from "../../components/nav/Navbar/Navbar";
import styles from "./Dashboard.module.scss";

type DashboardConfig = {
  src: string;
  title: string;
};

const DEFAULT_DASHBOARD: DashboardConfig = {
  src: "https://app.powerbi.com/view?r=eyJrIjoiZjE2YzUxMmUtOTA2ZS00ODRkLWIxNDMtMTNlMTk2MDY3MGM3IiwidCI6IjA4NjYyZGIxLTg0NmUtNDhiZC04ZWExLTJmZGU5MmQ2ZjVkZSIsImMiOjl9",
  title: "dashboard-shared",
};

const Dashboard = () => {
  const { src, title } = DEFAULT_DASHBOARD;

  return (
    <div className={styles.appWrapper}>
      <Navbar />
      <div className={styles.pageContainer}>
        <div className={styles.iframeWrapper}>
          <iframe
            className={styles.dashboardFrame}
            title={title}
            src={src}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
